/**
 * Base Components Export
 * Central export point for all reusable base components
 */

export { default as MoneyInput } from './MoneyInput.vue';
export { default as BaseSkeleton } from './BaseSkeleton.vue';
export { default as StatsCardSkeleton } from './StatsCardSkeleton.vue';

// Component registration helper
export function registerBaseComponents(app) {
  const components = {
    MoneyInput: () => import('./MoneyInput.vue'),
    BaseSkeleton: () => import('./BaseSkeleton.vue'),
    StatsCardSkeleton: () => import('./StatsCardSkeleton.vue')
  };
  
  Object.entries(components).forEach(([name, component]) => {
    app.component(name, component);
  });
}